export const card_selecionado = {
  computed: {
    card_selecionado: {
      get() {
        return this.$store.getters["comprasPorDepartamentos/card_ativo"]
      },
      set(novo_valor) {
        this.$store.dispatch("comprasPorDepartamentos/card_ativo", novo_valor)
      }
    }
  }
};
